import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';

// Redux
import { saveCartCountStatus } from './index';

// Api's
import { quoteApi } from '../../api';
import { GetCartCountStatus } from './cartCountStatusTypes';
import { CartResponseCount } from '@/main/models/response';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getCartCountStatusSaga(action: GetCartCountStatus) {
  try {
    const response: AxiosResponse<Result<CartResponseCount[]>> = yield call(
      quoteApi.countCartStatus,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveCartCountStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveCartCountStatus(null, true, resultError.messagesDataError));
    }
  }
}